import * as firebase from 'firebase';

let initialized = false;

export default {
    init(config) {
        initialized = true;
        firebase.initializeApp(config);
    },
    instance() {
        if (!initialized) throw new Error('Firebase not initialized.');

        return firebase;
    }
};
